export const ogrodData = {
    order: 6,
    name: 'ogrod',
    title: 'Ogród',
    iconSrc: 'pic_ogrod.svg',
    headlineText:
        'Wprowadź ekologię do swojego ogródka poprzez odpowiedzialne i zrównoważone gospodarowanie zasobami!',
    mainText:
        'W naturalnym ogródku człowiek jest tylko konserwatorem, a nie architektem. Taki ogródek nie jest doskonały, ale za to uczy na nowo szacunku dla przyrody i zrozumienia naturalnych zjawisk. Około 20% roślin zapylanych jest przez wiatr, a 80% przez owady, warto więc zdać sobie sprawę, że równo przycięty trawnik i egzotyczne rośliny to dla owadów „zielona pustynia" na której nie ma życia. Co zrobić, aby przywrócić równowagę w ogrodzie?',
    mainVideoSrc: '',
    odpadySection: [
        {
            text: 'Jeśli masz wystarczająco dużo miejsca, załóż własny kompostownik.',
        },
    ],
    klimatSection: [
        {
            text:
                'Niektóre rośliny są szczególnie przyjazne pszczołom i przyczyniają się do ich ochrony. Wybierając kwiaty do swojego ogrodu, koniecznie zwróć na to uwagę.',
        },
        {
            text:
                'Załóż własny, ekologiczny ogródek/warzywniak – nic nie będzie smakować tak dobrze, jak to, co sam wyhodujesz w ogrodzie!',
        },
        {
            text:
                'Nie stosuj środków chemicznych i pestycydów w ogrodzie. Używając ich pozbywasz się nie tylko szkodników, ale też pożytecznych owadów, więc podczas kolejnej inwazji szkodliwych organizmów ogród pozostaje bez ochrony.',
        },
        {
            text:
                'Postaw domki dla owadów – dzięki nim zwabisz do swojego ogrodu pożytecznych sojuszników w starciu ze szkodnikami.',
        },
        {
            text:
                'Aby zminimalizować ryzyko pojawienia się chorób i szkodników, stosuj metodę płodozmianu.',
        },
        {
            text:
                'Zimą warto zatroszczyć się o zwierzęta. Postaw w ogrodzie karmniki, a w okresie zimowym otrzymasz od Miasta ziarna dla ptaków.',
        },
        {
            text:
                'Jastrzębie-Zdrój bardzo dba o zwierzęta i zachęca do tego mieszkańców. Mile widziane są takie działania jak pomoc schroniskom, postawienie w ogrodzie budek lęgowych dla ptaków i sadzenie drzew.',
        },
    ],
    energiaSection: [],
    powietrzeSection: [],
    wodaSection: [
        {
            text: 'Do podlewania roślin w ogrodzie wykorzystaj deszczówkę. ',
        },
        {
            text: '',
            picSrc: 'pics/pic-18.png',
            caption: '40% obszarów na powierzchni Ziemi ma utrudniony dostęp do wody pitnej!',
        },
        {
            text:
                'Dbaj o zasoby wodne i zainwestuj w instalację służącą retencjonowaniu deszczówki. Jako mieszkaniec Jastrzębia-Zdroju możesz otrzymać aż 5 tys. zł dofinansowania na instalację zatrzymującą wodę, taką jak podziemny zbiornik na wody opadowe i roztopowe, naziemny zamknięty wolnostojący zbiornik na wody opadowe i roztopowe, system bioretencji czy system nawadniania terenów zielonych.',
        },
        {
            text: '',
            picSrc: 'pics/pic-19.png',
            caption: '2,1 mld osób na świecie nie ma dostępu do czystej wody pitnej!',
        },
        {
            text: '',
            picSrc: 'pics/pic-22.png',
            caption: '55% - o tyle wzrośnie zapotrzebowanie na wodę pitną do 2050 r.',
        },
    ],
    czyWieszSection: [
        {
            text: '...w ciągu doby musisz dostarczyć do swojego ogrodu aż 10 litrów wody/m²?... ',
            more:
                'Ogród należy nawadniać przez cały sezon wegetacyjny, czyli przez 120 dni. Przy założeniu, że Twój ogród ma 300 m², zużyjemy nawet 360 000 litrów wody rocznie! Daje to rachunek rzędu 3600 złotych.',
        },
        {
            text: '...szacunkowo praca pszczół w Polsce jest warta ponad 4 mld zł rocznie?...',
            more:
                'Wlicza się w to nie tylko produkcja miodu, ale też zapylanie krzewów i drzew owocowych. Niestety, pszczoły są obecnie zagrożone, czego głównymi sprawcami są między innymi intensyfikacja rolnictwa, nadmierne czy nieprawidłowe stosowanie środków ochrony roślin i nawozów, zanieczyszczenie środowiska i zmiana klimatu.' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://poradnikogrodniczy.pl/oszczedzanie_wody.php ">https://poradnikogrodniczy.pl/oszczedzanie_wody.php </a>' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="http://naukawpolsce.pap.pl/aktualnosci/news%2C77146%2C20-maja-swiatowy-dzien-pszczol.html ">http://naukawpolsce.pap.pl/aktualnosci/news%2C77146%2C20-maja-swiatowy-dzien-pszczol.html </a>',
        },
    ],
};
